import React from 'react'
import PropTypes from 'prop-types'
import Seo from '../../common/SEO/Seo'
import MousePointer from '../../common/MousePointer/MousePointer'

const Layout = ({
  children,
  title,
  description,
  header,
  footer,
  cookies,
  contactForm,
  configurator
}) => (
  <>
    {cookies}
    <Seo
      title={title}
      description={description}
    />
    <div className='min-h-screen flex flex-col'>
      <MousePointer />
      {header}
      {contactForm}
      <main className={`flex-grow ${!configurator && 'mt-10'}`}>
        {children}
      </main>
      {footer}
    </div>
  </>
)

export default Layout

Layout.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  description: PropTypes.string,
  header: PropTypes.node,
  footer: PropTypes.node,
  cookies: PropTypes.node,
  contactForm: PropTypes.node,
  configurator: PropTypes.bool
}

Layout.defaultProps = {
  indexPage: false,
  header: null,
  footer: null,
  cookies: null,
  configurator: false
}
